import { useSyncExternalStore } from "react";

export interface Claimant {
    id: string;
    name: string;
    claimedAt: string;
}

// Claiming happens in the Requests drawer (employee side); "claim activity" is read from
// the manager's Windows list. Both need the same live view of who claimed what, so this
// is a small shared store instead of component-local state that only one side can see.
type ClaimMap = Record<string, Claimant>;

let claims: ClaimMap = {};
const listeners = new Set<() => void>();

const emit = () => listeners.forEach((listener) => listener());

export const claimsStore = {
    getSnapshot: () => claims,
    subscribe: (listener: () => void) => {
        listeners.add(listener);
        return () => listeners.delete(listener);
    },
    setClaim: (shiftId: string, claimant: Omit<Claimant, "claimedAt">) => {
        claims = { ...claims, [shiftId]: { ...claimant, claimedAt: new Date().toISOString() } };
        emit();
    },
    clearClaim: (shiftId: string) => {
        if (!(shiftId in claims)) return;
        const next = { ...claims };
        delete next[shiftId];
        claims = next;
        emit();
    },
};

export const useClaims = () => useSyncExternalStore(claimsStore.subscribe, claimsStore.getSnapshot);
